interface LayerTimeline {
  [key: string]: PropertyTimeline;
  visibility: PropertyTimeline;
}

class PropertyTimeline {
  points: TimelinePoint[];

  static createFromData(data: any): PropertyTimeline {
    const res = new PropertyTimeline();
    res.points = data.points;
    return res;
  }

  constructor() {
    this.reset();
  }

  clean() {
    // clean left
    const p0 = this.points[0];
    const p1 = this.points[1];
    if (p0.position === 0 && p1.position === 0) {
      // remove first point
      this.points.shift();
    }
    const lastP = this.points[this.points.length - 1];
    const beforeLastP = this.points[this.points.length - 2];
    if (lastP.position === 1 && beforeLastP.position === 1) {
      // remove last
      this.points.pop();
    }
  }

  reset() {
    this.points = [
      {
        position: 0,
        value: 1
      },
      {
        position: 1,
        value: 1
      }
    ];
  }

  getValueAt(position: number): number {
    position = position % 1;
    let prevIndex = -1;
    for (let i = 0; i < this.points.length; i++) {
      const p = this.points[i];
      if (p.position === position) {
        return p.value;
      }
      if (p.position < position) {
        prevIndex = i;
      }
    }
    const prevPoint = this.points[prevIndex];
    const nextPoint = this.points[prevIndex + 1];
    const phase =
      (position - prevPoint.position) /
      (nextPoint.position - prevPoint.position);
    return prevPoint.value + phase * (nextPoint.value - prevPoint.value);
  }

  isCustom(): boolean {
    if (this.points.length > 2) {
      return true;
    }
    const firstPoint = this.points[0];
    const secondPoint = this.points[1];
    return firstPoint.value !== 1 || secondPoint.value !== 1;
  }

  asData(): Object {
    const points = this.points.map(p => {
      return { position: p.position, value: p.value };
    });
    return { points };
  }
}

interface TimelinePoint {
  position: number;
  value: number;
}

const TIMELINE_VISIBILITY_KEY = 'visibility';

export {
  LayerTimeline,
  PropertyTimeline,
  TimelinePoint,
  TIMELINE_VISIBILITY_KEY
};



// WEBPACK FOOTER //
// ./src/data/LayerTimeline.ts